<template>
    <q-select
        dense
        square
        outlined
        use-input
        :value="model"
        :behavior="$q.platform.is.ios || $q.platform.is.android ? 'menu' : 'default'"
        hide-selected
        input-debounce="0"
        :options="options"
        @filter="search"
        @input-value="setModel"
        @input="selected($event)"
        :option-label="(item) => item ? label(item) : ''"
        label="Поиск товаров"
        hide-dropdown-icon
        @keyup.enter.native="submit"
        class="q-menu-search"
    >
        <template v-slot:append>
            <span @click.prevent="submit"></span>
        </template>
        <template v-slot:loading>
        </template>

    </q-select>
</template>

<script>
    export default {
        name: "Search",
        data () {
            return {
                model: '',
                options: [],
            }
        },
        methods: {
            setModel (value) {
                this.model = value;
            },
            submit () {
                window.location.href = '/catalog/?search=' + this.model;
            },
            search (val, update, abort, event) {
                let _this = this;

                if (val.length < 3) {
                    update(() => {
                        _this.options = [];
                    });
                } else {
                    axios.get('/suggestion/' + val)
                        .then(response => {

                            if (response.data.status === 'success') {
                                update(() => {
                                    _this.options = response.data.suggestions;
                                });
                            } else {
                                update(() => {
                                    _this.options = [];
                                });
                            }
                        })
                        .catch(error => {
                            update(() => {
                                _this.options = [];
                            });
                        });
                }
            },
            label (item) {
                if (item.highlight) {
                    return item.highlight;
                } else {
                    return this.highlight(item.title);
                }

            },
            highlight (string) {
                let replacements = this.model.split(' ');

                _.each(replacements, function (replacement) {

                    if (string.replace(replacement, '') === string) {

                        for (let i = replacement.length; i > 2; i--) {
                            replacement = replacement.substring(0, replacement.length - 1);

                            if (string.replace(replacement, '') !== string) {
                                string = string.replace(replacement, `<strong class="text-primary">${replacement}</strong>`);
                                break;
                            }
                        }

                    } else {
                        string = string.replace(replacement, `<strong class="text-primary">${replacement}</strong>`);
                    }
                })

                return string;
            },
            selected (item) {
                if (item.url) {
                    window.location.href = `/${item.url}/`;
                }
            }
        }
    }
</script>
